
$(function() {
     // TOPページMOVIEスライダーの設定
     new Swiper('#toppage-movie-slider.swiper-container', {
        speed: 1000,
        effect: 'slide',
        pagination: {
            el: '#toppage-movie-slider .swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                if (index === 0) {
                    return '<span class="' + className + ' custom-bullet">' + 'MAKING' + '</span>';
                } else if (index === 1) {
                    return '<span class="' + className + ' custom-bullet">' + 'HISTORY' + '</span>';
                } else {
                    return '<span class="' + className + ' custom-bullet">' + 'OTHERS' + '</span>';
                }
            },
        },
        loop: true,
    });

    // 動画の再生位置開始補正
    // 参考：https://teratail.com/questions/204973
    $('.recipe-movie-video a').on('click', function() {
        $('#recipe-movie-popup video').get(0).currentTime = 0;
        $('#recipe-movie-popup video').get(0).play();
    });

    // 動画を閉じた時、停止させる(音を止めるため)
    // 参考：https://github.com/jsor/lity#events
    $(document).on('lity:close', function(event, instance) {
        $('#recipe-movie-popup video').get(0).pause();
    });

    // 括弧を親の高さめいっぱいにする
    $('.zairyo-bracket img').each(function() {
        var parHeight = $(this).parent().parent().height();
        $(this).height(parHeight);
        $(this).width(13);
    });

    // アカウント情報
    // モーダルを取得
  var modal = document.getElementById("account-modal");

  // モーダルを開くボタンを取得
  var btn = document.getElementById("open-modal");

  // 閉じるボタンを取得
  var span = document.getElementsByClassName("close")[0];

  // ボタンがクリックされたらモーダルを開く
  btn.onclick = function() {
    modal.style.display = "block";
  }

  // 閉じるボタンがクリックされたらモーダルを閉じる
  span.onclick = function() {
    modal.style.display = "none";
  }

  // モーダル外をクリックしたらモーダルを閉じる
  window.onclick = function(event) {
    if (event.target == modal) {
      modal.style.display = "none";
    }
  }
});